import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  EditButton,
  ShowButton,
  Filter,
  TextInput,
  ReferenceArrayInput,
  SelectArrayInput,
  DateField,
  ChipField,
  DateInput,
} from "react-admin";
import { SUPERADMIN } from "../../constant/TypeRole";
import Actions from '../Actions'

const AnnounceFilter = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <Filter {...props}>
      <TextInput source="title_contains" />
      {/* <DateInput label='Expire' source="expire_gt" /> */}
      {/* <TextInput label='Type' source="type_contains" /> */}
      <ReferenceArrayInput
        alwaysOn
        style={{ minWidth: "200px" }}
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
    </Filter>
  );
};

export const AnnounceList = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
  return (
    <List
      {...props}
      title="announce.announce"
      bulkActions={false}
      actions={<Actions create />}
      filters={<AnnounceFilter />}
      filterDefaultValues={filter}
    >
      <Datagrid>
        <div />
        <TextField source="title" />
        <DateField
          source="expire"
          locales="th-TH"
          options={{ year: "numeric", month: "long", day: "numeric" }}
        />
        <ReferenceField source="project" reference="project" linkType={false}>
          <ChipField source="name" />
        </ReferenceField>
        <EditButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/announce/AnnounceList.js